import { render, staticRenderFns } from "./NewGuest.vue?vue&type=template&id=21abed72"
import script from "./NewGuest.vue?vue&type=script&lang=js"
export * from "./NewGuest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports